/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ runner: NonNullable<unknown>, name: NonNullable<unknown> }} Agent_Access_Title_RunnerInputs */



/**
* | output |
* | --- |
* | "{runner} can't run \"{name}\". It uses things {runner} doesn't have access to:" |
*
* @param {Agent_Access_Title_RunnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_title_runner = /** @type {((inputs: Agent_Access_Title_RunnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Title_RunnerInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.runner} kann „${i?.name}“ nicht ausführen. Der Agent nutzt Dinge, auf die ${i?.runner} keinen Zugriff hat:`)
	return /** @type {LocalizedString} */ (`${i?.runner} can't run "${i?.name}". It uses things ${i?.runner} doesn't have access to:`)
});